import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PostmanService {

    openInPostman(errorLog, bearerToken) {
        const postmanURL = this.generatePostmanCollection(errorLog, bearerToken);
        console.log('Postman URL:', postmanURL); // Debugging line to check URL

        // Open Postman with the generated collection
        window.open(postmanURL, '_self'); // Use '_self' instead of '_blank' to avoid browser behavior
    }

    downloadCurlCommand(errorLog, bearerToken) {
        const curlCommand = this.generateCurlCommand(errorLog, bearerToken);

        // Create a Blob from the cURL command string
        const blob = new Blob([curlCommand], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);

        // Create a temporary link element for downloading
        const a = document.createElement('a');
        a.href = url;
        a.download = `curl_${errorLog.traceReference}.sh`; // Name of the file
        document.body.appendChild(a);
        a.click(); // Programmatically click the link to trigger the download
        document.body.removeChild(a); // Remove the link element from the document

        // Clean up the URL object
        URL.revokeObjectURL(url);
    }

    copyCurlCommandToClipboard(errorLog, bearerToken) {
        const curlCommand = this.generateCurlCommand(errorLog, bearerToken);
        // Copy to clipboard
        navigator.clipboard.writeText(curlCommand).then(() => {
            // Optionally, you can show a notification to the user
            alert('Postman cURL command copied to clipboard for import!');
        }).catch(err => {
            console.error('Failed to copy postman cURL: ', err);
        });
    }

    generateCurlCommand(errorLog, bearerToken) {
        // Start the cURL command
        let curlCommand = `curl -X ${errorLog.endPointMethod} "${errorLog.endPointUrl}"`;

        // Add headers
        curlCommand += ' -H "Content-Type: application/json"';
        if (bearerToken) {
            curlCommand += ` -H "Authorization: Bearer ${bearerToken}"`;
        }

        // Add the body if it exists
        if (errorLog.endPointPayload) {
            let jsonPayload;

            if (typeof errorLog.endPointPayload === 'string') {
                // If it's already a string, use it directly
                jsonPayload = errorLog.endPointPayload.replace(/'/g, "\\'"); // Escape single quotes if necessary
            } else {
                // Otherwise, stringify the object
                jsonPayload = JSON.stringify(errorLog.endPointPayload).replace(/'/g, "\\'");
            }

            curlCommand += ` -d '${jsonPayload}'`; // Add the payload to the cURL command
        }

        return curlCommand;
    }

    downloadPostmanCollection(errorLog, bearerToken) {
        const postmanCollection = this.generatePostmanCollection(errorLog, bearerToken);
        const jsonCollection = JSON.stringify(postmanCollection, null, 2); // Pretty print for readability

        // Create a Blob from the JSON string
        const blob = new Blob([jsonCollection], { type: 'application/json' });
        const url = URL.createObjectURL(blob);

        // Create a temporary link element for downloading
        const a = document.createElement('a');
        a.href = url;
        a.download = `postman_${errorLog.traceReference}.json`; // Name of the file
        document.body.appendChild(a);
        a.click(); // Programmatically click the link to trigger the download
        document.body.removeChild(a); // Remove the link element from the document

        // Clean up the URL object
        URL.revokeObjectURL(url);
    }

    generatePostmanCollection(errorLog, bearerToken) {
        const headers = [
            {
                key: 'Content-Type',
                value: 'application/json',
                type: 'text'
            }
        ];

        // If a Bearer Token is provided, add it to the Authorization header
        if (bearerToken) {
            headers.push({
                key: 'Authorization',
                value: `Bearer ${bearerToken}`,
                type: 'text'
            });
        }

        const postmanCollection = {
            info: {
                name: "Generated Collection",
                schema: "https://schema.getpostman.com/json/collection/v2.1.0/collection.json"
            },
            item: [
                {
                    name: `API Request - ${errorLog.traceReference}`,
                    request: {
                        method: errorLog.endPointMethod,
                        header: headers,
                        url: {
                            raw: errorLog.endPointUrl,
                            protocol: 'http', // or 'https', depending on your URL
                            host: errorLog.endPointUrl.split('/').slice(2, 3), // Extracting the host
                            path: errorLog.endPointUrl.split('/').slice(3).join('/') // Joining the remaining parts as path
                        },
                        body: errorLog.endPointPayload ? {
                            mode: "raw",
                            raw: JSON.stringify(errorLog.endPointPayload)
                        } : undefined
                    }
                }
            ]
        };

        // Convert the collection to JSON and encode it in base64
        const jsonCollection = JSON.stringify(postmanCollection);
        const base64Collection = btoa(jsonCollection);
        return `postman-collection://?collection=${base64Collection}`; // Updated URI
    }
}